export default __webpack_public_path__ + "static/media/soundtrackYourBrand-logo-white.528abd26.png";